import React from 'react';
import {useTranslation} from 'react-i18next';

import {showModal} from '@edna/components';
import EditIcon from '@edna/icons/edit.svg';

import {SecondaryText} from 'src/components/primitives';

import {ResponsibleManagerModal} from './ResponsibleManagerModal';
import {useGetAccountManagersQuery} from './api';
import * as S from './style';

type TProps = {
  responsibleManagerId?: number;
  responsibleManagerName?: string;
};

export const ResponsibleManager = React.memo<TProps>(
  ({responsibleManagerId, responsibleManagerName}) => {
    const {t} = useTranslation();

    const {data: accountManagers = []} = useGetAccountManagersQuery();

    const managerName = React.useMemo(
      () =>
        accountManagers.find((item) => item.id === responsibleManagerId)?.name ??
        responsibleManagerName,
      [accountManagers, responsibleManagerId, responsibleManagerName],
    );

    const handleEdit = React.useCallback(
      () =>
        showModal((closeModal) => (
          <ResponsibleManagerModal
            closeModal={closeModal}
            responsibleManagerId={responsibleManagerId}
          />
        )),
      [responsibleManagerId],
    );

    return (
      <S.Section>
        <SecondaryText>{t('LeadCompanyClients:leadClientCard.responsibleManager')}</SecondaryText>
        <S.ManagerName>
          {managerName ?? t('LeadCompanyClients:leadClientCard.empty')}
          <S.EditButton onClick={handleEdit} data-selector="editButton">
            <EditIcon />
          </S.EditButton>
        </S.ManagerName>
      </S.Section>
    );
  },
);

ResponsibleManager.displayName = 'ResponsibleManager';
